import {translationsNext} from './actionTypes';
import {createHttpAction} from "../Next/http-fetch";

export const i18n_getTranslations = (language) => createHttpAction(
  translationsNext,
  null,
  {params: {language}},
  {language},
).action;
